"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DefaultModule = _interopRequireDefault(require("../../scss/blocks/ad-themes/Default.module.scss"));
var _Round2Module = _interopRequireDefault(require("../../scss/blocks/ad-themes/Round2.module.scss"));
var _TabloTvModule = _interopRequireDefault(require("../../scss/blocks/ad-themes/TabloTv.module.scss"));
var _ImageOnlyModule = _interopRequireDefault(require("../../scss/blocks/ad-themes/ImageOnly.module.scss"));
function AdBlock(_ref) {
  let {
    image,
    ad,
    theme = 'default'
  } = _ref;
  const themeMap = new Map([['default', _DefaultModule.default], ['round2', _Round2Module.default], ['tablotv', _TabloTvModule.default], ['imageonly', _ImageOnlyModule.default]]);
  const styles = themeMap.get(theme);
  const linkParams = ad.campaign === '' ? '' : "?utm_campaign=".concat(ad.campaign, "&utm_source=").concat(ad.source, "&utm_medium=").concat(ad.medium, "&utm_content=").concat(ad.content);
  const adCopyRef = (0, _react.useRef)();
  const adImageRef = (0, _react.useRef)();
  const ctaRef = (0, _react.useRef)();
  const logoRef = (0, _react.useRef)();
  const mobileLogoRef = (0, _react.useRef)();
  const mobileDisclaimerRef = (0, _react.useRef)();
  const adLink = "".concat(ad.href).concat(linkParams);
  const triggerAnimation = (0, _react.useCallback)((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (theme === 'tablotv') {
          ctaRef.current.classList.add("".concat(styles['ad-cta--animate']));
          mobileDisclaimerRef.current.classList.add("".concat(styles['ad-mobile-disclaimer--animate']));
        }
        adCopyRef.current.classList.add("".concat(styles['ad-copy--animate']));
        adImageRef.current.classList.add("".concat(styles['ad-image--animate']));
        observer.unobserve(adImageRef.current);
      }
    });
  }, [styles]);
  (0, _react.useEffect)(() => {
    if (theme !== 'imageonly') {
      const adimageObserver = new IntersectionObserver(triggerAnimation, {
        root: null,
        rootMargin: "0px",
        threshold: 0.1
      });
      adimageObserver.observe(adImageRef.current);
      return () => {
        adimageObserver.disconnect();
      };
    }
  }, [theme, triggerAnimation]);
  return /*#__PURE__*/_react.default.createElement("ad-block", {
    class: "".concat(styles['ad-anchor']),
    onClick: event => {
      // ensure tab isn't opened twice if clicking directly on the cta
      if (event.target === ctaRef.current || event.target === logoRef.current || event.target === mobileLogoRef.current) {
        event.preventDefault();
      }
      window.open(ctaRef.current, '_blank');
    }
  }, theme === 'imageonly' ? /*#__PURE__*/_react.default.createElement("a", {
    className: styles['cta-container__link'],
    href: adLink,
    target: "_blank",
    rel: "noreferrer",
    ref: ctaRef
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, image.text)) : theme === 'tablotv' ? /*#__PURE__*/_react.default.createElement("div", {
    className: styles['background-container']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles['ad-copy'],
    ref: adCopyRef
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: styles['ad-copy__header']
  }, ad.header), /*#__PURE__*/_react.default.createElement("div", {
    className: styles['ad-image-mobile'],
    ref: adImageRef
  }, /*#__PURE__*/_react.default.createElement("ad-image", null, /*#__PURE__*/_react.default.createElement("a", {
    href: adLink,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image.mobile,
    alt: image.altText,
    ref: mobileLogoRef
  })))), /*#__PURE__*/_react.default.createElement("p", {
    className: styles['ad-copy__description']
  }, ad.description)), /*#__PURE__*/_react.default.createElement("div", {
    className: styles['cta-container']
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: styles['cta-container__link'],
    href: adLink,
    target: "_blank",
    rel: "noreferrer",
    ref: ctaRef
  }, ad.linkText), /*#__PURE__*/_react.default.createElement("span", {
    className: styles['ad-image__text'],
    ref: mobileDisclaimerRef
  }, image.text)), /*#__PURE__*/_react.default.createElement("div", {
    className: styles['ad-image'],
    ref: adImageRef
  }, /*#__PURE__*/_react.default.createElement("ad-image", null, /*#__PURE__*/_react.default.createElement("a", {
    href: adLink,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image.url,
    alt: image.altText,
    ref: logoRef
  }))), /*#__PURE__*/_react.default.createElement("span", {
    className: styles['ad-image__text']
  }, image.text))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: styles['ad-image'],
    ref: adImageRef
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: styles['ad-image__text']
  }, image.text), /*#__PURE__*/_react.default.createElement("ad-image", null, /*#__PURE__*/_react.default.createElement("a", {
    href: adLink,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: image.url,
    alt: image.altText,
    ref: logoRef
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: styles['ad-copy'],
    ref: adCopyRef
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: styles['ad-copy__header']
  }, ad.header), /*#__PURE__*/_react.default.createElement("p", {
    className: styles['ad-copy__description']
  }, ad.description), /*#__PURE__*/_react.default.createElement("a", {
    className: styles['ad-copy__link'],
    href: adLink,
    target: "_blank",
    rel: "noreferrer",
    ref: ctaRef
  }, ad.linkText))));
}
var _default = exports.default = AdBlock;